import {formatDistanceToNow} from 'date-fns';
import {
    SavedTranslationRow,
    TranslationMode
} from '../../api/assistant/savedTranslations.ts';
import {tabNameForSlot} from '../projects/tabs/projectTabSlots.ts';

// Saved times come from the server in UTC without the zone.
export const savedAgo = (createdOnUtc: string) =>
    formatDistanceToNow(
        new Date(
            createdOnUtc.endsWith('Z') ? createdOnUtc : createdOnUtc + 'Z'
        ),
        {addSuffix: true}
    );

export const modeLabel = (mode: TranslationMode) =>
    mode === TranslationMode.Guide ? 'Guide' : 'Translation';

// Where a saved translation was made, from its PageKey (see the panel).
export const pageLinkFor = (row: SavedTranslationRow): string | null => {
    const project = /^project:([^:]+):(\d)$/.exec(row.pageKey);
    if (project) {
        return `/project/${project[1]}?tab=${tabNameForSlot(
            Number(project[2])
        )}`;
    }
    return row.pageKey.startsWith('page:') ? row.pageKey.slice(5) : null;
};
